import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";

import { useBrandsStore } from "@/store/brands";


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandProductProfile',
  props: {
  brandId: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const brandStore = useBrandsStore();
const brandProfile = computed(() => brandStore.profiles[props.brandId]);
const brandLogo = computed(() => brandProfile.value?.optimizedLogoImage);

return { __sfc: true,props, brandStore, brandProfile, brandLogo }
}

})